<template>
  <div
    :class="[
      'up-nav-avatar-indicator flex items-center text-xs justify-center cursor-pointer h-8 w-8 rounded-full font-medium select-none',
      isUserImpersonated
        ? 'bg-warning-100 text-warning-900'
        : 'bg-info-100 text-info-900',
    ]"
    :style="{
      width: size,
      height: size,
    }"
    @click="emit('click')"
  >
    {{ userInitials }}
  </div>
</template>

<script setup lang="ts">
defineProps<{
  userInitials: string;
  size?: string;
  isUserImpersonated: boolean;
}>();

const emit = defineEmits<{
  click: [];
}>();
</script>
